import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUserGroups } from 'hooks/useUserGroups';

const ManagerRoute = () => {
  const { hasGroup, isLoading } = useUserGroups();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-600">Vérification des permissions...</div>
      </div>
    );
  }

  if (!hasGroup('managers')) {
    // Redirect to home page if user doesn't have manager access
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ManagerRoute;
